import { render, staticRenderFns } from "./ModalMaterialsPurchaseRequest.vue?vue&type=template&id=39a0047c"
import script from "./ModalMaterialsPurchaseRequest.vue?vue&type=script&lang=js"
export * from "./ModalMaterialsPurchaseRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports